const options = {
  5: "bg-gray-600/5",
  10: "bg-gray-600/10",
  25: "bg-gray-600/25",
  50: "bg-gray-600/50",
  75: "bg-gray-600/75",
  90: "bg-gray-600/90",
  100: "bg-gray-600",
};

const from = {
  5: "from-gray-600/5",
  10: "from-gray-600/10",
  25: "from-gray-600/25",
  50: "from-gray-600/50",
  75: "from-gray-600/75",
  90: "from-gray-600/90",
  100: "from-gray-600",
};

export default function getBackgroundGray600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
